import React, {useState, useEffect} from "react";
import Modal from "react-modal";
import Web3 from "web3";
import Staking from '../abi/staking.json';
import pTGC from '../abi/pTGC.json';
import {txAfterDone, txDone, txStart} from "../utils";
import Swal  from "sweetalert2";
import { parseUnits } from "ethers";

const StakePopup = ({ modalIsOpen, closeModal, account, providers, unstakedpTGC, minStaking, pTGCAllowance, updatePage}) => {
  const [amount, setAmount] = useState('');

  useEffect(() => {
      if (Number(amount) > unstakedpTGC && unstakedpTGC > minStaking) 
      {
          setAmount(unstakedpTGC)
      }
      if (String(amount).includes(".")) 
      {
          let input_string = String(amount)
          let newAmount = input_string.match(/^\d+\.\d{0,0}/)[0]
          setAmount(Number(newAmount))
      }
  }, [amount, unstakedpTGC]);

  const stakeToken = async () => {
    const web3 = new Web3(providers);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
    const finalAmount = parseUnits(String(amount), 18);
    try {
      await stakingContract.methods.deposit(String(finalAmount)).send({
        from: account
      }).on('transactionHash', function(payload) {
        closeModal()
        txStart();
      }).on('error', function(error) {
        Swal.fire({
          title: "Please try again",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Ok",
          showCloseButton: true,
          customClass: {
            confirmButton: "btn btn-danger"
          }
        });
      }).then(function(receipt) {
        updatePage()
        txDone()
        setTimeout(() => {
          txAfterDone()
        }, 2000)
      });
    } catch (error) {
      txDone();
      txAfterDone();
      Swal.fire({
        title: "Please try again",
        text: error.message,
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Ok",
        showCloseButton: true,
        customClass: {
          confirmButton: "btn btn-danger"
        }
      });
    }
  }

  const approveToken = async () => {
    const web3 = new Web3(providers);
    const pTGCContract = new web3.eth.Contract(pTGC.ABI, pTGC.Contract);
    const finalAmount = parseUnits(String(amount), 18);
    try {
      await pTGCContract.methods.approve(pTGC.Contract, String(finalAmount)).send({
        from: account
      }).on('transactionHash', function(payload) {
        closeModal()
        txStart();
      }).on('error', function(error) {
        Swal.fire({
          title: "Please try again",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Ok",
          showCloseButton: true,
          customClass: {
            confirmButton: "btn btn-danger"
          }
        });
      }).then(function(receipt) {
        txDone()
        setTimeout(() => {
          txAfterDone()
        }, 2000)
        stakeToken();
      });
    } catch (error) {
      txDone();
      txAfterDone();
      Swal.fire({
        title: "Please try again",
        text: error.message,
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Ok",
        showCloseButton: true,
        customClass: {
          confirmButton: "btn btn-danger"
        }
      });
    }
  }

  const afterOpenModal = () => {
    setAmount('');
  };

  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} onAfterOpen={afterOpenModal} contentLabel="Modal">
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="PTGCSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="mb-0 mt-2  w-100 good_times goldFont ">Stake In Pool</h2>
            </div>
              <div className="row justify-content-center mt-4">
                <div className="col-sm-8 col-md-6 col-lg-5">
                  <div className="">
                  <div className="bSRIN overHide p-0">
                  <div className="bSRIN overHide mt-0 w-5100" style={{ border: '0px', borderRadius:'0px', borderBottom: '0px solid #383835' }}>
                    <div className="amountSTaking d-flex1 justify-content-between align-items-center gap-3" >
                      <div className="d-flex gap-2 w-100 inputBGCOin">
                        <img className="img-fluid" src="./images/ptgccircle.svg" />
                        <input
                          type="text"
                          className="nobginput w-100"
                          placeholder="0.00"
                          value={
                            amount === "" || isNaN(Number(amount.toString().replace(/,/g, "")))
                              ? ""
                              : Number(amount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "") {
                              setAmount("");
                              return;
                            }
                            if (isNaN(raw)) return;
                            const num = Math.min(Number(raw), Number(unstakedpTGC));
                            setAmount(num.toString());
                          }}
                        />
                      </div>
                      <div className="perVal fInter d-flex align-items-center justify-content-start mt-3">
                        <span className="">Available Amount : <span className="text-white">{parseFloat(unstakedpTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PTGC</span></span>
                      </div>
                      <div className="someBtns d-flex gap-2 mt-3 modnoCOlo">
                        <button className="someSnbtn w-100" onClick={() => { setAmount((25 / 100) * unstakedpTGC) }}><span>25%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((50 / 100) * unstakedpTGC) }}><span>50%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((75 / 100) * unstakedpTGC) }}><span>75%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((100 / 100) * unstakedpTGC) }}><span>100%</span></button>
                      </div>
                    </div>
                  </div>
                  <div className="someBtns SRTOP  d-flex gap-2 mt-0 p-2">
                      {
                        amount > 0 ?
                          pTGCAllowance >= amount && amount > 0 ?
                            <button className="someSnbtn w-100" onClick={() => { stakeToken() }}>
                              <span className="d-flex align-items-center justify-content-between">Stake Now
                                <div className="iconSR"><img className="img-fluid" src="./images/circlewithdraw.svg" /></div>
                              </span>
                            </button>
                          :
                            <button className="someSnbtn w-100" onClick={() => { approveToken() }}>
                              <span className="d-flex align-items-center justify-content-between">Approve & Stake Now
                                <div className="iconSR"><img className="img-fluid" src="./images/circlewithdraw.svg" /></div>
                              </span>
                            </button>
                        :
                        <button className="someSnbtn w-100 disabled" disabled>
                          <span className="d-flex align-items-center justify-content-between">Stake Now
                            <div className="iconSR"><img className="img-fluid" src="./images/circlewithdraw.svg" /></div>
                          </span>
                        </button>
                      }
                  </div>
                </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    </Modal>
    </>
  );
};

export default StakePopup;